import { useUBL } from '@common/log-manager';

export const useWelcomeBannerUBL = () => {
  const sendUBL = useUBL();

  const bannerImpressionUBL = () => {
    sendUBL({
      category: 'impression',
      navigation: 'product_detail',
      object_type: 'banner',
      object_id: 'welcome_benefit',
    });
  };

  const bannerClickUBL = () => {
    sendUBL({
      category: 'click',
      navigation: 'product_detail',
      object_type: 'banner',
      object_id: 'welcome_benefit',
    });
  };

  return { bannerImpressionUBL, bannerClickUBL };
};
